import * as NextSkyTheme from "@NextSkyTheme/global";
import { eventModal } from "@NextSkyTheme/modal";

if (!customElements.get("outfit-item")) {
  customElements.define(
    "outfit-item",
    class OutfitItem extends HTMLElement {
      constructor() {
        super();
        this.isAction = this.querySelector("outfit-action");
      }

      connectedCallback() {
        this.isAction.addEventListener(
          "click",
          this.initPopup.bind(this),
          false
        );
        this.isAction.addEventListener(
          "keypress",
          function (event) {
            if (event.key === "Enter") {
              this.initPopup.bind(this)(event);
            }
          }.bind(this),
          false
        );
      }

      initPopup() {
        const template = this.querySelector("template.outfit-popup");
        if (template) {
          const content = document.createElement("div");
          content.appendChild(
            template.content.firstElementChild.cloneNode(true)
          );
          const popup = content.querySelector("outfit-popup");
          NextSkyTheme.getBody().appendChild(popup);
          
          // Setup variant selectors listeners
          setTimeout(() => {
            this.setupVariantSelectors(popup);
          }, 150);
          
          setTimeout(
            () => eventModal(popup, "open", true),
            100
          );
        }
        NextSkyTheme.global.rootToFocus = this.isAction;
      }

      setupVariantSelectors(popup) {
        const selects = popup.querySelectorAll(".select-variant-bundle");
        selects.forEach((select) => {
          select.addEventListener("change", (e) => {
            this.handleVariantChange(e.target, popup);
          });
        });
      }

      handleVariantChange(select, popup) {
        const productId = select.getAttribute("data-product-id");
        const selectedOption = select.options[select.selectedIndex];
        
        if (!selectedOption) return;

        const variantId = selectedOption.value;
        const variantPrice = selectedOption.getAttribute("data-price");
        const variantComparePrice = selectedOption.getAttribute("data-compare-price");

        // Update hidden input with new variant data (for bundle form)
        const variantInput = popup.querySelector(`.variant-select[product-id="${productId}"] input[name="items[][id]"]`);
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.setAttribute("data-price", variantPrice);
          variantInput.setAttribute("data-compare-price", variantComparePrice);
        }

        // Update product-variant-bundle-id inputs (for individual add to cart buttons)
        const productCard = select.closest('.product-item');
        if (productCard) {
          const bundleInputs = productCard.querySelectorAll('.product-variant-bundle-id');
          bundleInputs.forEach(input => {
            input.value = variantId;
          });
        }

        // Trigger price recalculation
        this.recalculateTotalPrice(popup);
      }

      recalculateTotalPrice(popup) {
        const submitButton = popup.querySelector(".product_submit_button");
        if (!submitButton) return;

        let totalPrice = 0;
        let totalComparePrice = 0;
        const prices = [];

        popup.querySelectorAll(".variant-select").forEach((item) => {
          const priceInput = item.querySelector('input[name="items[][id]"]');
          if (priceInput) {
            const price = Number(priceInput.getAttribute("data-price")) || 0;
            const comparePrice = Number(priceInput.getAttribute("data-compare-price")) || price;
            totalPrice += price;
            totalComparePrice += comparePrice;
            prices.push({ price, comparePrice });
          }
        });

        const enableDiscount = submitButton.getAttribute("data-enable-discount") === "true";
        const discountType = submitButton.getAttribute("data-discount-type");
        const discountPercentage = Number(submitButton.getAttribute("data-discount-percentage")) || 0;
        const discountFixed = Number(submitButton.getAttribute("data-discount-fixed")) || 0;
        const priceDisplayType = submitButton.getAttribute("data-price-display-type");

        let originalPrice = totalPrice;
        let finalPrice = totalPrice;

        if (enableDiscount) {
          if (priceDisplayType === "compare_price") {
            originalPrice = totalComparePrice;
          }

          let discountAmount = 0;
          if (discountType === "percentage") {
            discountAmount = (originalPrice * discountPercentage) / 100;
          } else if (discountType === "fixed") {
            discountAmount = discountFixed * 100;
          } else if (discountType === "cheapest_free") {
            // Find the cheapest item
            let cheapestPrice = Infinity;
            prices.forEach((item) => {
              const itemPrice = priceDisplayType === "compare_price" ? item.comparePrice : item.price;
              if (itemPrice < cheapestPrice) {
                cheapestPrice = itemPrice;
              }
            });
            discountAmount = cheapestPrice !== Infinity ? cheapestPrice : 0;
          }
          finalPrice = Math.max(0, originalPrice - discountAmount);

          const finalPriceElement = popup.querySelector(".outfit-price-final");
          const comparePriceElement = popup.querySelector(".outfit-price-compare");

          if (finalPriceElement && window.Shopify && window.Shopify.formatMoney) {
            finalPriceElement.innerHTML = window.Shopify.formatMoney(finalPrice);
          }

          if (comparePriceElement && window.Shopify && window.Shopify.formatMoney) {
            comparePriceElement.innerHTML = window.Shopify.formatMoney(originalPrice);
          }
        } else {
          const priceElements = popup.querySelectorAll(".outfit-btn-content-simple .price");
          priceElements.forEach((element) => {
            if (window.Shopify && window.Shopify.formatMoney) {
              element.innerHTML = window.Shopify.formatMoney(totalPrice);
            }
          });
        }
      }
    }
  );
}
